'use strict';

class BalanceTable {
  constructor(salesLedgerService, recipientService) {
    this.salesLedgerService = salesLedgerService;
    this.recipientService = recipientService;
  }

  $onInit() {
    this.invoiceNumber = null;
    this.recipientNumber = null;
    this.salesledger = {
      invoice: 0,
      recipient: 0
    };

    this.load();
  }

  $onChanges() {
    this.load();
  }

  load() {
    if (this.invoiceNumber && this.invoiceNumber !== null) {
      this.salesLedgerService.getInvoiceBalance(this.invoiceNumber)
        .then((balance) => {
          this.salesledger.invoice = balance.data.balance;
        });
    }

    if (this.recipientNumber && this.recipientNumber !== null) {
      this.recipientService.getBalance(this.recipientNumber)
        .then((recipient) => {
          this.salesledger.recipient = recipient.data.balance;
        });
    }
  }
}

BalanceTable.$inject = ['salesLedgerService', 'recipientService'];

const balanceTable = {
  bindings: {
    invoiceNumber: '<',
    recipientNumber: '<'
  },
  controller: BalanceTable,
  template: `
    <table>
      <tr>
        <td>Saldo for denne regningen:</td>
        <th class="nowrap">{{ $ctrl.salesledger.invoice | crowns }}</th>
      </tr>
      <tr>
        <td>Saldo for denne mottageren:</td>
        <th class="nowrap">{{ $ctrl.salesledger.recipient | crowns }}</th>
      </tr>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('balanceTable', balanceTable);
